<template>
  <v-card>
    <div style="width: 100%; position: relative;">
      <h3 style="font-weight: 600; font-size: 18px; text-align: center; padding-top: 30px;">
        Histórico de Solicitação
      </h3>
      <v-btn
        icon
        style="position: absolute; right: 20px; top: 25px;"
        @click="closeModal"
      >
        <v-icon size="30">
          {{ icons.mdiClose }}
        </v-icon>
      </v-btn>
    </div>
    <section
      class="pa-12 d-flex flex-column"
      style="gap: 32px;"
    >
      <span style="font-size: 14px; color: #E7E3FC; font-weight: 600;">N° SLT: <strong style="color:#FF821A; font-weight: 400;">0{{ solicData.code || '-' }}</strong></span>
      <v-timeline
        dense
        align-top
        outlined
        style="margin-left: -6px;"
        class="timeline-custom-dense timeline-custom-dots"
      >
        <v-timeline-item
          v-for="(item, index) in historyArr"
          :key="index"
          color="newOrange"
          outlined
          small
        >
          <TransportTimelineItem
            :solic-data="solicData"
            :item="item"
            @getHistory="handleGetHistory"
          />
        </v-timeline-item>
      </v-timeline>
    </section>
  </v-card>
</template>

<script>
import axiosIns from '@/plugins/axios'
import formatters from '@/plugins/formattersMixin1'
import messages from '@/plugins/showMessageMixin'
import { mdiClose } from '@mdi/js'
import TransportTimelineItem from './TransportTimelineItem.vue'

export default {
  name: 'HistoryModal',
  components: {
    TransportTimelineItem,
  },
  mixins: [formatters, messages],
  props: {
    solicData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      historyArr: [],
      icons: {
        mdiClose,
      },
    }
  },
  created() {
    this.handleGetHistory()
  },
  methods: {
    async handleGetHistory() {
      try {
        const { data } = await axiosIns.get(`/api/v1/solicitations/transport_solicitation_trip_history/get_by_trip_id/${this.solicData.id}`)
        this.historyArr = data.data || []
      } catch (error) {
        console.error('Error fetching history:', error)
        this.showErrorMessage('Erro ao buscar histórico da solicitação.')
      }
    },
  },
}
</script>

<style>

</style>
